// src/admin/pros/ProKpiStrip.jsx
import React from "react";

export default function ProKpiStrip({ pros, activeKpi, onKpiClick }) {
  const total = pros.length;
  const active = pros.filter(p => p.status === "active").length;
  const pending = pros.filter(p => p.status === "pending").length;
  const suspended = pros.filter(p => p.status === "suspended").length;
  const topEarners = pros.filter(p => p.earnings >= 20000).length;

  const cards = [
    { label: "Total Pros", value: total, key: "all" },
    { label: "Active", value: active, key: "active" },
    { label: "Pending Approval", value: pending, key: "pending" },
    { label: "Suspended", value: suspended, key: "suspended" },
    { label: "Top Earners", value: topEarners, key: "top" },
  ];

  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(5, 1fr)",
      gap: 12,
      marginBottom: 24
    }}>
      {cards.map(card => (
        <div
          key={card.key}
          onClick={() => onKpiClick(card.key)}
          style={{
            background: "#FFFFFF",
            border: `1px solid ${activeKpi === card.key ? "#0F172A" : "#E2E8F0"}`,
            borderRadius: 10,
            padding: "16px 20px",
            cursor: "pointer",
            transition: "all 0.2s ease",
            position: "relative",
            borderBottom: activeKpi === card.key ? "3px solid #059669" : "1px solid #E2E8F0"
          }}
          onMouseEnter={e => {
            if (activeKpi !== card.key) {
              e.currentTarget.style.borderColor = "#CBD5E1";
            }
          }}
          onMouseLeave={e => {
            if (activeKpi !== card.key) {
              e.currentTarget.style.borderColor = "#E2E8F0";
            }
          }}
        >
          <div style={{
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontSize: 12,
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "0.04em",
            color: "#94A3B8",
            marginBottom: 8
          }}>
            {card.label}
          </div>
          <div style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 28,
            fontWeight: 700,
            color: "#0F172A"
          }}>
            {card.value}
          </div>
        </div>
      ))}
    </div>
  );
}